import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { drapcodeIcon } from '../../common/custom/icon-library';
import {
  menuItemsForActivity,
  getAppSettingBasePath,
  isAppSettingActive,
} from '../../common/utils/api_utils';

const ActivityMenu = () => {
  const { pathname } = useLocation();
  const { projectId, version } = useParams();

  const dropdownColor = menuItemsForActivity.some((item) =>
    isAppSettingActive(pathname, item.key, version, projectId),
  )
    ? 'theme-green--dropdown'
    : 'theme-primary--dropdown';

  return (
    <UncontrolledDropdown group className="ml-2">
      <DropdownToggle color={dropdownColor} title="Activity Logs" className="btn-md" caret>
        <i className="webconnect webconnect-clock-history"></i> Activity Logs
      </DropdownToggle>
      <DropdownMenu>
        {menuItemsForActivity.map((item) => {
          const to = getAppSettingBasePath(item.key, version, projectId);
          const activeClass = isAppSettingActive(pathname, item.key, version, projectId)
            ? 'active'
            : '';
          return (
            <DropdownItem
              key={item.key}
              tag={Link}
              to={to}
              className={`theme-primary ${activeClass}`}
            >
              <i className={`wb ${item.directIcon ? item.icon : drapcodeIcon(item.icon)}`}></i>
              &nbsp;
              {item.label}
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default ActivityMenu;
